import { useState } from "react";
import SectionTitle from "../ui/SectionTitle";
import GalleryTile from "../ui/GalleryTile";
import GalleryLightbox from "../ui/GalleryLightbox";

function GallerySection({ t, tiles }) {
  const [activeTile, setActiveTile] = useState(null);

  return (
    <section
      className="landing-section gallery-section-dark"
      id="gallery"
      data-nav-section="gallery"
    >
      <div className="container">
        <SectionTitle label={t.title} variant="dark" />

        <div className="gallery-mosaic gallery-mosaic--preview">
          {tiles.map((tile) => (
            <GalleryTile
              key={tile.id}
              tile={tile}
              alt={t.alt[tile.id]}
              videoLabel={t.videoLabel}
              onOpen={setActiveTile}
            />
          ))}
        </div>
      </div>

      {activeTile && (
        <GalleryLightbox
          item={activeTile}
          alt={activeTile.alt}
          closeLabel={t.closeLabel}
          onClose={() => setActiveTile(null)}
        />
      )}
    </section>
  );
}

export default GallerySection;
